export enum MentionMeSituation {
  PostPurchaseMainsite = 'postpurchase-mainsite',
  PostPurchaseMirrorsite = 'postpurchase-mirrorsite',
}
